module.exports = __webpack_public_path__ + "img/lambang_gms.da14f81f.jpg";